import {useRef} from "react";

// Keeps two scrollable panes (e.g. a plain-text editor and its rendered markdown preview)
// scrolled to the same relative position. A plain boolean echo-guard breaks under mouse-wheel
// scrolling — several real scroll events fire from the same source before the other pane's
// programmatic echo event arrives — so this tags the specific element whose next scroll event
// is the echo to ignore, rather than blindly toggling a flag.
export function useSyncedScroll() {
  const suppressRef = useRef(null);

  return (source, target) => {
    if (!source || !target) return;
    if (suppressRef.current === source) {
      suppressRef.current = null;
      return;
    }
    const denom = source.scrollHeight - source.clientHeight;
    const ratio = denom > 0 ? source.scrollTop / denom : 0;
    suppressRef.current = target;
    target.scrollTop = ratio * (target.scrollHeight - target.clientHeight);
  };
}

export default useSyncedScroll;
